import { wertelisteState, werte} from "./wertelisteTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../../../app/store";

const werteDummy: werte
  = {
    wertname: "",
};

const initialState: wertelisteState 
  = {
    aktuellerWert: werteDummy,
};

const wertelisteSlice = createSlice({
  name: "werteliste",
  initialState,
  reducers: 
  {
    setAktuellerWert: (state, action: PayloadAction<string>) => {
      state.aktuellerWert.wertname = action.payload;
    }
  }
});

export const selectAktuellerWert = (state: RootState): werte =>
  state.werteliste.aktuellerWert;


export const {
  setAktuellerWert
} = wertelisteSlice.actions;
export default wertelisteSlice.reducer;